import { render } from "./MailSendJob.vue?vue&type=template&id=0ee896be&scoped=true"
import script from "./MailSendJob.vue?vue&type=script&lang=js"
export * from "./MailSendJob.vue?vue&type=script&lang=js"

import "./MailSendJob.vue?vue&type=style&index=0&id=0ee896be&scoped=true&lang=css"

import exportComponent from "/home/projects/frontend.vendor-mailing-system.pravin/vendor-mailig-system/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0ee896be"]])

export default __exports__